import {
  Button,
  ButtonGroup,
  Image,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalOverlay,
  Stack,
  Text,
} from '@chakra-ui/react';

import SolidButton from '@/client/components/shared/buttons/SolidButton';

interface DarkModalProps {
  isOpen: boolean;
  onClose: () => void;
  imageSrc: string;
  title: string;
  description: string;
  submitButton: {
    label: string;
    onClick: () => void;
  };
  cancelButton: {
    label: string;
    onClick: () => void;
  };
}

export default function DarkModal({
  isOpen,
  onClose,
  imageSrc,
  title,
  description,
  submitButton,
  cancelButton,
}: DarkModalProps) {
  return (
    <Modal isCentered size="xl" isOpen={isOpen} onClose={onClose}>
      <ModalOverlay background="blackAlpha.800" />

      <ModalContent padding={0} borderRadius="16px" backgroundColor="#232323">
        <ModalBody padding={0} color="white">
          <Image borderTopRadius="16px" width="full" height="auto" src={imageSrc} alt={title} />

          <Stack paddingX={6} paddingY={8} spacing={4}>
            <Text fontSize="18px" fontWeight={600}>
              {title}
            </Text>

            <Text fontSize="14px" fontWeight={400}>
              {description}
            </Text>
          </Stack>
        </ModalBody>

        <ModalFooter paddingX={6} paddingBottom={8} justifyContent="flex-start">
          <ButtonGroup>
            <SolidButton width="fit-content" onClick={submitButton.onClick}>
              {submitButton.label}
            </SolidButton>

            <Button
              variant="ghost"
              color="white"
              _hover={{ color: 'white' }}
              onClick={cancelButton.onClick}
            >
              {cancelButton.label}
            </Button>
          </ButtonGroup>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
